import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { PageCount as PageCount$1 } from '../../../PageCount/PageCount.js';
import { usePageCount } from './hooks/usePageCount.js';

var PageCount = /*#__PURE__*/React.memo(/*#__PURE__*/React.forwardRef(function (props, ref) {
  var _usePageCount = usePageCount(props),
    shouldRender = _usePageCount.shouldRender,
    containerStyles = _usePageCount.containerStyles,
    pageCountProps = _usePageCount.pageCountProps;
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, containerStyles), /*#__PURE__*/React.createElement(PageCount$1, pageCountProps));
}));
PageCount.displayName = 'CarouselV3.PageCount';

export { PageCount };
//# sourceMappingURL=PageCount.js.map
